import { render, staticRenderFns } from "./AdminReviews.vue?vue&type=template&id=793c13d7&scoped=true"
import script from "./AdminReviews.vue?vue&type=script&lang=js"
export * from "./AdminReviews.vue?vue&type=script&lang=js"
import style0 from "./AdminReviews.vue?vue&type=style&index=0&id=793c13d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793c13d7",
  null
  
)

export default component.exports